module.exports = __webpack_public_path__ + "isle-of-man.svg?f136875fe80b2e90a602b00e7ab5d3a8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/isle-of-man.svg
// module id = 195
// module chunks = 10